
import { Component, Mixins, Watch } from "vue-property-decorator";
import { IItem } from "../../../../../../../domain/document/items";
import { TextValueAccessor } from "../accessors";
import { default as ObjectReferableContentMixin } from "./ObjectReferableContentMixin.vue";

@Component
export default class TextInputtableContentMixin extends Mixins(ObjectReferableContentMixin) {
  data() {
    return {
      accessor: null as TextValueAccessor,
      error: "",
    };
  }
  accessor: TextValueAccessor;
  error: string;

  get text(): string {
    return this.accessor
      ? this.accessor.get()
      : "";
  }

  set text(value: string) {
    if (this.accessor) {
      this.updateItem(this.accessor.set(value));
    }
  }

  get isFatal(): boolean {
    return !this.accessor;
  }

  mounted() {
    this.initialize(this.item);
  }

  @Watch("item")
  onItemUpdated(newValue: IItem) {
    this.initialize(newValue);
  }

  initialize(newValue: IItem) {
    try {
      this.accessor = new TextValueAccessor(newValue);
      this.accessor.validate();
      this.error = "";
    } catch (e) {
      this.accessor = null;
      this.error = e.message;
    }
  }
}
